import { ContentTypeText, LangText, OptionHeader, QualityText } from "../zustand/dict";

export const makeOptionList = (artData) => {
    let settingData = [];
    if (artData.negativePrompt) {
        settingData.push(<><OptionHeader type="nt" /> {" " + artData.negativePrompt}</>)
    }

    if (artData.contentType) {
        settingData.push(<><OptionHeader type="ctt" />{" "}<ContentTypeText value={artData.contentType} /></>)
    }

    if (artData.promptStrength || artData.promptStrength == 0) {
        // settingData.push("Prompt Strength " + artData.promptStrength)
        settingData.push(<><OptionHeader type="ps" /> {" " + artData.promptStrength}</>)
    }

    if (artData.imageStyle) {
        // settingData.push("" + artData.imageStyle)
        // settingData.push(<><OptionHeader type="st" /> {" " + artData.imageStyle}</>)
        settingData.push(<><OptionHeader type="st" />{" "}<LangText id={artData.imageStyle} /></>)
    }

    if (artData.imageStyleFile) {
        settingData.push(<><OptionHeader type="st" />{" "}<OptionHeader type="stf" /></>)
    }

    if (artData.styleStrength || artData.styleStrength == 0) {
        // settingData.push("Style Strength " + artData.styleStrength)
        settingData.push(<><OptionHeader type="ss" /> {" " + artData.styleStrength}</>)
    }

    if (artData.photoStrength || artData.photoStrength == 0) {
        // settingData.push("Photo Strength " + artData.photoStrength)
        settingData.push(<><OptionHeader type="phs" /> {" " + artData.photoStrength}</>)
    }

    if (artData.videoStrength || artData.videoStrength == 0) {
        // settingData.push("Video Strength " + artData.videoStrength)
        settingData.push(<><OptionHeader type="vs" /> {" " + artData.videoStrength}</>)
    }

    if (artData.videoStyle) {
        // settingData.push("Style " + artData.videoStyle)
        // settingData.push("" + artData.videoStyle)
        settingData.push(<><OptionHeader type="st" />{" "}<LangText id={artData.videoStyle} /></>)
    }

    settingData.push(artData.share ? <OptionHeader type="public" /> : <OptionHeader type="private" />);


    if (artData.width && artData.height) {
        function gcd(a, b) {
            return b === 0 ? a : gcd(b, a % b);
        }

        function calculateAspectRatio(width, height) {
            if (width == "680") {
                return "2:3"
            } else if (height == "680") {
                return "3:2"
            }

            const divisor = gcd(width, height);
            const aspectWidth = width / divisor;
            const aspectHeight = height / divisor;

            return `${aspectWidth}:${aspectHeight}`;
        }

        // settingData.push(calculateAspectRatio(artData.width, artData.height))
        settingData.push(<><OptionHeader type="resol" /> {" " + calculateAspectRatio(artData.width, artData.height)}</>)
    }

    if (artData.multipleOption) {
        // settingData.push(artData.multipleOption + "x")

        if (["가로", "세로", "정사각"].includes(artData.multipleOption)) {
            settingData.push(<><OptionHeader type={
                artData.multipleOption === "세로" ? "tvv" :
                    artData.multipleOption === "가로" ? "tvh" : "tvr"
            } /></>)
        } else {
            settingData.push(<>{artData.multipleOption}<OptionHeader type="x" /></>)
        }
    }

    if (artData.sampler) {
        // settingData.push(artData.sampler)
        settingData.push(<><OptionHeader type="sample" /> {" " + artData.sampler}</>)
    }

    if (artData.layoutOption) {
        if (artData.layoutOption == "horizontal") {
            settingData.push(<><OptionHeader type="ea" />{" "}<LangText id={"option_selector_layout1"} /></>)
        } else if (artData.layoutOption == "vertical") {
            // settingData.push(<LangText id={"option_selector_layout2"} />)
            settingData.push(<><OptionHeader type="ea" />{" "}<LangText id={"option_selector_layout2"} /></>)
        } else {
            settingData.push(<><OptionHeader type="ea" />{" " + artData.layoutOption}</>)
        }
    }

    if (artData.qualityOption) {
        settingData.push(<><OptionHeader type="qo" />{" "}<QualityText value={artData.qualityOption} /></>)
    }

    if (artData.seed) {
        // settingData.push("Seed " + artData.seed)
        settingData.push(<><OptionHeader type="seed" /> {" " + artData.seed}</>)
    }

    if (artData.step) {
        // settingData.push("Step " + artData.step)
        settingData.push(<><OptionHeader type="step" /> {" " + artData.step}</>)
    }

    return settingData
}